import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// Routes
import CampaignContainer from '~/features/campaigns/components/campaign/CampaignContainer';
import CampaignListContainer from '~/features/campaigns/components/campaignList/CampaignListContainer';
import { useLocation } from 'react-router';

export const CampaignRoute = ({ match }) => {
    const location = useLocation();
    const campaignRef = React.useRef(location.state?.campaign);

    if (location.state?.campaign) {
        campaignRef.current = location.state.campaign;
    }
    return (
        <Switch>
            <Route path={`${match.path}/:campaignId`}
                   component={(props) => <CampaignContainer {...props} campaign={campaignRef.current}/>}/>
            <Route path={`${match.path}`} component={(props) => <CampaignListContainer {...props}/>}/>
            <Redirect path={`${match.path}`}/>
        </Switch>
    );
};

export default CampaignRoute;
